import { ExperimentPhase, ExperimentPhaseType } from "api/models";

export function checkIsCurrentPhase(
  targetPhase?: ExperimentPhaseType,
  currentPhase?: ExperimentPhase | null,
) {
  return !!currentPhase && currentPhase.type === targetPhase;
}
